export const DOCUMENT_TEMPLATES_LIST = {
  DOCUMENT_TITLE: { key: 'DOCUMENT_TITLE', value: 'Documents' },
  DESIGN_INSPIRATION_TITLE: { key: 'DESIGN_INSPIRATION_TITLE', value: 'Design Inspirations' },
  DOCUMENT_DESCRIPTION: {
    key: 'DOCUMENT_DESCRIPTION',
    value:
      'Design, edit, update your documents, reusables used in the document and referenced contents',
  },
  DESIGN_INSPIRATION_DESCRIPTION: {
    key: 'DESIGN_INSPIRATION_DESCRIPTION',
    value: 'Design inspirations for documents and mail templates',
  },
  ADD_NEW_DOCUMENT_TOOLTIP: {
    key: 'ADD_NEW_DOCUMENT_TOOLTIP',
    value: 'Add new document template',
  },
  LOADING_MORE: {
    key: 'LOADING_MORE',
    value: 'Loading more...',
  },
  GOT_ALL_TEMPLATES_LIST: {
    key: 'GOT_ALL_TEMPLATES_LIST',
    value: 'You have got all results',
  },
  DELETE_TEMPLATE_DROPDOWN_OPTION: {
    key: 'DELETE_TEMPLATE_DROPDOWN_OPTION',
    value: 'Delete',
  },
  EDIT_TEMPLATE_DROPDOWN_OPTION: {
    key: 'EDIT_TEMPLATE_DROPDOWN_OPTION',
    value: 'Edit',
  },
  EMPTY_MASTER_TEMPLATES_LIST: {
    key: 'EMPTY_MASTER_TEMPLATES_LIST',
    value: 'Templates list is empty',
  },
  EMPTY_TEMPLATES_LIST: { key: 'EMPTY_TEMPLATES_LIST', value: 'Templates list is empty. Click' },
  CREATE_NEW_TEMPLATE_INFO: {
    key: 'CREATE_NEW_TEMPLATE_INFO',
    value: 'to create new template',
  },
  CREATE_NEW_TEMPLATE_ACTION: { key: 'CREATE_NEW_TEMPLATE_ACTION', value: 'here' },
};

export const EMAIL_TEMPLATES_LIST = {
  EMAIL_TITLE: { key: 'EMAIL_TITLE', value: 'Email' },
  EMAIL_DESCRIPTION: {
    key: 'EMAIL_DESCRIPTION',
    value:
      'Design, edit, update your mail templates, reusables used in the mail templates and referenced contents',
  },
  ADD_NEW_EMAIL_TOOLTIP: {
    key: 'ADD_NEW_EMAIL',
    value: 'Add new email template',
  },
  LOADING_MORE: {
    key: 'LOADING_MORE',
    value: 'Loading more...',
  },
  GOT_ALL_TEMPLATES_LIST: {
    key: 'GOT_ALL_TEMPLATES_LIST',
    value: 'You have got all results',
  },
  DELETE_TEMPLATE_DROPDOWN_OPTION: {
    key: 'DELETE_TEMPLATE',
    value: 'Delete',
  },
  EDIT_TEMPLATE_DROPDOWN_OPTION: {
    key: 'EDIT_TEMPLATE',
    value: 'Edit',
  },
  EMPTY_TEMPLATES_LIST: { key: 'EMPTY_TEMPLATES_LIST', value: 'Templates list is empty. Click' },
  CREATE_NEW_TEMPLATE_INFO: {
    key: 'CREATE_NEW_TEMPLATE_INFO',
    value: 'to create new template',
  },
  CREATE_NEW_TEMPLATE_ACTION: { key: 'CREATE_NEW_TEMPLATE_ACTION', value: 'here' },
};

export const SHORT_MESSAGE_TEMPLATES_LIST = {
  SHORT_MESSAGE_TITLE: { key: 'SHORT_MESSAGE_TITLE', value: 'Short Messages' },
  SHORT_MESSAGE_DESCRIPTION: {
    key: 'SHORT_MESSAGE_DESCRIPTION',
    value: 'Design, edit, update, test & manage sms, whatsapp and automated phone calls',
  },
  SHORT_MESSAGE_DESCRIPTION_WHATSAPP_DISABLED: {
    key: 'SHORT_MESSAGE_DESCRIPTION_WHATSAPP_DISABLED',
    value: 'Design, edit, update, test & manage sms and automated phone calls',
  },
  ADD_NEW_SMS_TOOLTIP: {
    key: 'ADD_NEW_SMS_TOOLTIP',
    value: 'SMS',
  },
  ADD_NEW_WHATSAPP_BUTTON_TEXT: {
    key: 'ADD_NEW_WHATSAPP_BUTTON_TEXT',
    value: 'WhatsApp',
  },
  ADD_NEW_VOICE_MESSAGE_TOOLTIP: {
    key: 'ADD_NEW_VOICE_MESSAGE_TOOLTIP',
    value: 'Voice Message',
  },
  LOADING_MORE: {
    key: 'LOADING_MORE',
    value: 'Loading more...',
  },
  GOT_ALL_TEMPLATES_LIST: {
    key: 'GOT_ALL_TEMPLATES_LIST',
    value: 'You have got all results',
  },
  DELETE_TEMPLATE_DROPDOWN_OPTION: {
    key: 'DELETE_TEMPLATE',
    value: 'Delete',
  },
  EDIT_TEMPLATE_DROPDOWN_OPTION: {
    key: 'EDIT_TEMPLATE',
    value: 'Edit',
  },
  EMPTY_TEMPLATES_LIST: { key: 'EMPTY_TEMPLATES_LIST', value: 'Templates list is empty. Click' },
  CREATE_NEW_TEMPLATE_INFO: {
    key: 'CREATE_NEW_TEMPLATE_INFO',
    value: 'to create new template',
  },
  CREATE_NEW_TEMPLATE_ACTION: { key: 'CREATE_NEW_TEMPLATE_ACTION', value: 'here' },
  ADD_NEW_CALL_MESSAGE_TOOLTIP: {
    key: 'ADD_NEW_CALL_MESSAGE_TOOLTIP',
    value: 'Add new call message',
  },
  ADD_NEW_SMS_MESSAGE_TOOLTIP: {
    key: 'ADD_NEW_SMS_MESSAGE_TOOLTIP',
    value: 'Add new sms message',
  },
  ADD_NEW_WHATSAPP_MESSAGE_TOOLTIP: {
    key: 'ADD_NEW_WHATSAPP_MESSAGE_TOOLTIP',
    value: 'Add new whatsapp message',
  },
};

export const ADVANCED_FILTER = {
  ADVANCED_FILTER_TITLE: {
    key: 'FILTER_TITLE',
    value: 'Advanced Search',
  },
  FILTER_CLEAR_ALL: {
    key: 'FILTER_CLEAR_ALL',
    value: 'Clear all filter',
  },
  FILTER_SEARCH_BUTTON: {
    key: 'FILTER_SEARCH_BUTTON',
    value: 'Search',
  },
  FILTER_BY_NAME_LABEL: {
    key: 'FILTER_BY_NAME_LABEL',
    value: 'Search by name',
  },
  FILTER_BY_NAME_PLACEHOLDER: {
    key: 'FILTER_BY_NAME_PLACEHOLDER',
    value: 'Search by name',
  },
  FILTER_BY_CATEGORY_LABEL: {
    key: 'FILTER_BY_CATEGORY_LABEL',
    value: 'Categories',
  },
  FILTER_BY_STATUS_LABEL: {
    key: 'FILTER_BY_STATUS_LABEL',
    value: 'Status',
  },
  FILTER_WAITING_FOR_APPROVAL_LABEL: {
    key: 'FILTER_WAITING_FOR_APPROVAL_LABEL',
    value: 'waiting for approval',
  },
  FILTER_BY_TAGS_LABEL: {
    key: 'FILTER_BY_TAGS_LABEL',
    value: 'search by tags',
  },
  FILTER_BY_TAGS_PLACEHOLDER: {
    key: 'FILTER_BY_TAGS_PLACEHOLDER',
    value: 'search by tags',
  },
  FILTER_SHOW_ALL_CATEGORIES_ACTION: {
    key: 'FILTER_SHOW_ALL_CATEGORIES_ACTION',
    value: 'more categories',
  },
  EMPTY_CATEGORIES_LIST: {
    key: 'EMPTY_CATEGORIES_LIST',
    value: 'Categories list is empty',
  },
  LANGUAGE_FILTER_LABEL: {
    key: 'LANGUAGE_FILTER_LABEL',
    value: 'Search By Language',
  },
  ALL_OPTION: {
    key: 'ALL_OPTION',
    value: 'All',
  },
};

export const DOCUMENT_AND_EMAIL_ELEMENTS_LIST = {
  REFERENCED_ELEMENT_TITLE: { key: 'REFERENCED_ELEMENT_TITLE', value: 'Referenced' },
  REUSABLE_ELEMENT_TITLE: { key: 'REUSABLE_ELEMENT_TITLE', value: 'Reusable' },
  ADD_NEW_REFERENCED_ELEMENT_TOOLTIP: {
    key: 'ADD_NEW_REFERENCED_ELEMENT_TOOLTIP',
    value: 'Add new referenced element',
  },
  ADD_NEW_REUSABLE_ELEMENT_TOOLTIP: {
    key: 'ADD_NEW_REUSABLE_ELEMENT_TOOLTIP',
    value: 'Add new reusable element',
  },
  LOADING_MORE: {
    key: 'LOADING_MORE',
    value: 'Loading more...',
  },
  GOT_ALL_ELEMENTS_LIST: {
    key: 'GOT_ALL_ELEMENTS_LIST',
    value: 'You have got all results',
  },
  DELETE_ELEMENT_DROPDOWN_OPTION: {
    key: 'DELETE_ELEMENT_DROPDOWN_OPTION',
    value: 'Delete',
  },
  EDIT_ELEMENT_DROPDOWN_OPTION: {
    key: 'EDIT_ELEMENT_DROPDOWN_OPTION',
    value: 'Edit',
  },
  ELEMENTS_LIST_EMPTY_TEXT: { key: 'ELEMENTS_LIST_EMPTY_TEXT', value: 'Elements list is empty' },
};

export const TRANSACTIONS = {
  GENERAL_TRANSACTIONS_TITLE: {
    key: 'GENERAL_TRANSACTIONS_TITLE',
    value: 'Select a template and upload your excel data to '
  },
  SELECT_A_TEMPLATE_STEP_TITLE: {
    key: 'SELECT_A_TEMPLATE_STEP_TITLE',
    value: 'Select a template'
  },
  UPLOAD_EXCEL_FILE_STEP_TITLE: {
    key: 'UPLOAD_EXCEL_FILE_STEP_TITLE',
    value: 'Upload Excel File'
  },
  WRONG_FILE_UPLOADED_ERROR_MESSAGE: {
    key: 'WRONG_FILE_UPLOADED_ERROR_MESSAGE',
    value: 'Please upload files in the excel format only to facilitate transactions'
  },
  LOADING_MORE_TEMPLATES_MESSAGE: {
    key: 'LOADING_MORE_TEMPLATES_MESSAGE',
    value: 'Loading more...',
  },
  GOT_ALL_TEMPLATES_MESSAGE: {
    key: 'GOT_ALL_TEMPLATES_MESSAGE',
    value: 'You have got all results',
  },
  SELECTED_TEMPLATE_TITLE: {
    key: 'SELECTED_TEMPLATE_TITLE',
    value: 'Selected Template'
  },
  TEMPLATE_VARIABLES_TITLE: {
    key: 'TEMPLATE_VARIABLES_TITLE',
    value: 'Variables'
  },
  TEMPLATE_VARIABLE_MISSING_ERROR_MESSAGE: {
    key: 'TEMPLATE_VARIABLE_MISSING_ERROR_MESSAGE',
    value: 'Variable {{missedArray}} is missing'
  },
  NO_VARIABLES: {
    key: 'NO_VARIABLES',
    value: 'Template has no variables'
  },
  SEE_ALL_TEMPLATE_VARIABLES_ACTION: {
    key: 'SEE_ALL_TEMPLATE_VARIABLES_ACTION',
    value: 'see all'
  },
  TEMPLATE_VARIABLES_DETAILS_ACTION: {
    key: 'TEMPLATE_VARIABLES_DETAILS_ACTION',
    value: 'details'
  },
  DOWNLOAD_SAMPLE_FILE_FORMAT_BUTTON: {
    key: 'DOWNLOAD_SAMPLE_FILE_FORMAT_BUTTON',
    value: 'sample format'
  },
  UPLOADING_SAMPLE_FILE_DATA: {
    key: 'UPLOADING_SAMPLE_FILE_DATA',
    value: 'Uploading Data....'
  },
  TO_MOBILE_MISSING_ERROR_MESSAGE: {
    key: 'TO_MOBILE_MISSING_ERROR_MESSAGE',
    value: 'To mobile number is missing in row'
  },
  MOBILE_COUNTRY_CODE_MISSING_ERROR_MESSAGE: {
    key: 'MOBILE_COUNTRY_CODE_MISSING_ERROR_MESSAGE',
    value: 'Country code is missing in row'
  },
  SERIAL_NUMBER_MISSING_ERROR_MESSAGE: {
    key: 'SERIAL_NUMBER_MISSING_ERROR_MESSAGE',
    value: 'Serial Number is missing'
  },
  ATTACHMENT_PASSWORD_MISSING_ERROR_MESSAGE: {
    key: 'ATTACHMENT_PASSWORD_MISSING_ERROR_MESSAGE',
    value: 'Attachment password field is missing'
  },
  ATTACHMENT_PASSWORD_REQUIRED_ERROR_MESSAGE: {
    key: 'ATTACHMENT_PASSWORD_REQUIRED_ERROR_MESSAGE',
    value: 'Since attached template is password protected, attachment Password is necessary'
  },
  TAG_VALUE_MISSING_ERROR_MESSAGE: {
    key: 'TAG_VALUE_MISSING_ERROR_MESSAGE',
    value: 'Tag value is missing'
  },
  TAG_VALUE_MISSING_DESCRIPTION_ERROR_MESSAGE: {
    key: 'TAG_VALUE_MISSING_DESCRIPTION_ERROR_MESSAGE',
    value: ' (If pdf is printable it should have atleast one tag value)'
  },
  INVALID_TYPE_IN_PRINTABLE_COLUMN_ERROR_MESSAGE: {
    key: 'INVALID_TYPE_IN_PRINTABLE_COLUMN_ERROR_MESSAGE',
    value: 'Printable in row {{x}} has invalid input type, please give a boolean value'
  },
  PLACEHOLDER_TEXT_BOOLEAN_TYPE_ERROR_MESSAGE: {
    key: 'PLACEHOLDER_TEXT_BOOLEAN_TYPE_ERROR_MESSAGE',
    value: '{{placeholderText}} has invalid input type, please give a boolean value'
  },
  BOOLEAN_TYPE_REQUIRED_ERROR_MESSAGE: {
    key: 'BOOLEAN_TYPE_REQUIRED_ERROR_MESSAGE',
    value: 'Row {{x}} has invalid input type, please give a boolean value'
  },
  INVALID_DATE_FORMAT_ERROR_MESSAGE: {
    key: 'INVALID_DATE_FORMAT_ERROR_MESSAGE',
    value: 'Row {{x}} has invalid date (use dd-MM-yyyy format)'
  },
  EMPTY_DATE_ERROR_MESSAGE: {
    key: 'EMPTY_DATE_ERROR_MESSAGE',
    value: 'Row {{x}} has  empty date value'
  },
  UPLOADED_EMPTY_EXCEL_FILE_ERROR_MESSAGE: {
    key: 'UPLOADED_EMPTY_EXCEL_FILE_ERROR_MESSAGE',
    value: 'Uploaded empty excel file!'
  },
  DRAG_AND_DROP_FILE_TITLE: {
    key: 'DRAG_AND_DROP_FILE_TITLE',
    value: 'Drag and drop the excel sheet'
  },
  DRAG_AND_DROP_FILE_FORMAT_TITLE: {
    key: 'DRAG_AND_DROP_FILE_FORMAT_TITLE',
    value: 'Drag and drop xls, Json or XML'
  },
  GENETRATE_BULK_TRANSACTIONS_DESCRIPTION: {
    key: 'DRAG_AND_DROP_FILE_DESC',
    value: 'Generate bulk transactions with simple file uploads'
  },
  DRAG_AND_DROP_FILE_DESCRIPTION: {
    key: 'DRAG_AND_DROP_FILE_DESC',
    value: 'Excel sheet containing data values for variables in the template, this data is used to'
  },
  GENERATE_DOCUMENT_MESSAGE: {
    key: 'GENERATE_DOCUMENT_MESSAGE',
    value: 'generate your document'
  },
  TEMPLATE_LIST_EMPTY_MESSAGE: {
    key: 'TEMPLATE_LIST_EMPTY_MESSAGE',
    value: 'Templates list is empty'
  },
  MOVE_TO_SELECT_A_TEMPLATE_STEP_BUTTON: {
    key: 'MOVE_TO_SELECT_A_TEMPLATE_STEP_BUTTON',
    value: 'Back'
  },
  PREMIUM_PLAN_LIMIT_REACHED: { key: 'PREMIUM_PLAN_LIMIT_REACHED', value: "You have reached the limit for PDF generations under your current plan. You can either wait until your quota renews next month or upgrade to an enterprise plan. For assistance with upgrading, please contact our support team at <a href='mailto:{{emailId}}'>{{emailId}}</a>." },
  STANDARD_PLAN_UPGRADE_MESSAGE: { key: 'STANDARD_PLAN_UPGRADE_MESSAGE', value: "In your standard plan, you've reached the transaction limit of {{transactionLimit}}. Please upgrade your plan." },
  FREE_PLAN_UPGRADE_MESSAGE: { key: 'FREE_PLAN_UPGRADE_MESSAGE', value: "In your free plan, you've reached the transaction limit of {{transactionLimit}}. Please upgrade your plan." },

  EMAIL_PREMIUM_PLAN_UPGRADE_MESSAGE: { 
    key: 'EMAIL_PREMIUM_PLAN_UPGRADE_MESSAGE', 
    value: "You have reached the email-sending limit for your current plan. You can wait for your quota to renew next month or upgrade to an enterprise plan. For assistance with upgrading, please contact our support team at <a href='mailto:{{emailId}}'>{{emailId}}</a>." },
  EMAIL_STANDARD_PLAN_UPGRADE_MESSAGE: { 
    key: 'EMAIL_STANDARD_PLAN_UPGRADE_MESSAGE', 
    value: "In your standard plan, you have reached the email-sending limit of {{emailTransactionLimit}}. Please upgrade your plan." },
  EMAIL_FREE_PLAN_UPGRADE_MESSAGE: { 
    key: 'EMAIL_FREE_PLAN_UPGRADE_MESSAGE', 
    value: "In your free plan, you have reached the email-sending limit of {{emailTransactionLimit}}. Please upgrade your plan." },
  FETCH_TEMPLATES_BY_CATEGORY_ERROR_MESSAGE: { 
    key: 'FETCH_TEMPLATES_BY_CATEGORY_ERROR_MESSAGE', 
    value: 'An error occurred while retrieving templates by category.' },
  FETCH_PUBLISHED_TEMPLATES_ERROR_MESSAGE: { 
    key: 'FETCH_PUBLISHED_TEMPLATES_ERROR_MESSAGE', 
    value: 'An error occurred while retrieving published email templates.' },
  NO_TEMPLATES_AVAILABLE_TEXT: { 
    key: 'NO_TEMPLATES_AVAILABLE_TEXT', 
    value: 'No templates available.' },
  FETCH_SELECTED_TEMPLATE_ERROR_MESSAGE: { 
    key: 'FETCH_SELECTED_TEMPLATE_ERROR_MESSAGE', 
    value: 'An error occurred when retrieving the template details.' },
  PROCESSING_REQUEST_INFO_MESSAGE: { 
    key: 'PROCESSING_REQUEST_INFO_MESSAGE', 
    value: 'Processing your request, please wait...' },
  PROVIDED_DATA_INVALID_ERROR_MESSAGE: { 
    key: 'PROVIDED_DATA_INVALID_ERROR_MESSAGE', 
    value: 'Data provided is not valid.' },
  REQUEST_SUBMIT_SUCCESS_MESSAGE: {
    key: 'REQUEST_SUBMIT_SUCCESS_MESSAGE',
    value: 'Your request has been submitted successfully. You can view the status under Dashboard → Job Monitoring.'
  },
  WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD:{
    key: 'WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD',
    value: 'This design contains some nested tables. Please try providing data with JSON / XML formats instead.'
  }
};

//PDF Transactions
export const PDF_TRANSACTIONS = {
  PDF_TRANSACTIONS_TITLE: {
    key: 'PDF_TRANSACTIONS_TITLE',
    value: 'Select a template and upload your excel data to generate pdf'
  },
  GENERATING_PDF_MESSAGE: {
    key: 'GENERATING_PDF_MESSAGE',
    value: 'Generating PDF'
  },
  UPLOADED_PDF_EMPTY_FILE_ERROR_MESSAGE: {
    key: 'UPLOADED_PDF_EMPTY_FILE_ERROR_MESSAGE',
    value: 'Uploaded empty file, please provide valid information to generate pdf'
  },
  TIME_OUT_ERROR_MESSAGE: {
    key: 'TIME_OUT_ERROR_MESSAGE',
    value: 'Request timed out.',
  },
  PDF_GENERATION_FAILED: {
    key: 'PDF_GENERATION_FAILED',
    value: 'Document generation failed.',
  },
  PDF_GENERATION_SUCCESS: {
    key: 'PDF_GENERATION_SUCCESS',
    value: 'Document generated successfully.',
  },
  BATCH_UPLOAD_SUCCESS_MESSAGE: {
    key: 'BATCH_UPLOAD_SUCCESS_MESSAGE',
    value: 'Your request has been successfully submitted. Please go to Dashboard -> Job Monitoring to check the status or download the files'
  },
  BATCH_DOWNLOAD_SUCCESS_MESSAGE:{
    key:'BATCH_DOWNLOAD_SUCCESS_MESSAGE',
    value:'The file has been successfully downloaded. You can also go to Dashboard -> Job Monitoring to check the status or download the files'
  },

  BATCH_PARTIAL_DOWNLOAD_SUCCESS_MESSAGE:{
    key:'BATCH_DOWNLOAD_PARTIAL_SUCCESS_MESSAGE',
    value:'{{Downloaded_file}} out of {{Actual_files}} files successfully downloaded. Please go to Dashboard -> Job Monitoring to review the reason for the failure'
  },
  BATCH_DOWNLOAD_FAILURE_MESSAGE:{
    key:'BATCH_DOWNLOAD_FAILURE_MESSAGE',
    value:'Sorry, unable to download the files. Please go to Dashboard -> Job Monitoring to check the status'
  }
}

//Email Transactions
export const EMAIL_TRANSACTIONS = {
  EMAIL_TRANSACTIONS_TITLE: {
    key: 'EMAIL_TRANSACTIONS_TITLE',
    value: 'Select a template and upload your excel data to send email'
  },
  SENDING_EMAIL_TEMPLATE_TO_MAIL: {
    key: 'SENDING_EMAIL_TEMPLATE_TO_MAIL',
    value: 'Sending Email'
  },
  SEND_EMAIL_FAILURE_ERROR_MESSAGE: {
    key: 'SEND_EMAIL_FAILURE_ERROR_MESSAGE',
    value: 'Unable to send email'
  },
  TO_EMAIL_MISSING_ERROR_MESSAGE: {
    key: 'TO_EMAIL_MISSING_ERROR_MESSAGE',
    value: 'To email address is missing'
  },
  UPLOADED_EMAIL_EMPTY_FILE_ERROR_MESSAGE: {
    key: 'UPLOADED_EMAIL_EMPTY_FILE_ERROR_MESSAGE',
    value: 'Uploaded empty file, please provide valid information to send email'
  },
  SEND_YOUR_EMAIL_MESSAGE: {
    key: 'SEND_YOUR_EMAIL_MESSAGE',
    value: 'send your email'
  },
  INVALID_EMAIL_ADDRESS_ERROR_MESSAGE: {
    key: 'INVALID_EMAIL_ADDRESS_MESSAGE',
    value: 'The email address provided is not valid'
  }
}

//Call Transactions
export const CALL_TRANSACTIONS = {
  CALL_TRANSACTIONS_TITLE: {
    key: 'CALL_TRANSACTIONS_TITLE',
    value: 'initiate a call'
  },
  INITIATING_CALL_MESSAGE: {
    key: 'INITIATING_CALL_MESSAGE',
    value: 'Initiating Call'
  },
  INITIATE_PHONE_CALL_ERROR_MESSAGE: {
    key: 'INITIATE_PHONE_CALL_ERROR_MESSAGE',
    value: 'Unable to initiate a phone call'
  },
}

//Message Transactions
export const MESSAGE_TRANSACTIONS = {
  SMS_TRANSACTIONS_TITLE: {
    key: 'SMS_TRANSACTIONS_TITLE',
    value: 'send SMS'
  },
  SENDING_SMS_MESSAGE: {
    key: 'SENDING_SMS_MESSAGE',
    value: 'Sending SMS'
  },
  SEND_MESSAGE_ERROR_MESSAGE: {
    key: 'SEND_MESSAGE_ERROR_MESSAGE',
    value: 'Unable to send message'
  },
  UPLOADED_SMS_EMPTY_FILE_ERROR_MESSAGE: {
    key: 'UPLOADED_SMS_EMPTY_FILE_ERROR_MESSAGE',
    value: 'Uploaded empty file, please provide valid information to send messages'
  },
}

//Whatsapp Transactions
export const WHATSAPP_TRANSACTIONS = {
  WHATSAPP_TRANSACTIONS_TITLE: {
    key: 'WHATSAPP_TRANSACTIONS_TITLE',
    value: 'send whatsapp message'
  },
  SENDING_WHATSAPP_MSG_MESSAGE: {
    key: 'SENDING_WHATSAPP_MSG_MESSAGE',
    value: 'Sending Whatsapp Message'
  },
  SEND_WHATSAPP_ERROR_MESSAGE: {
    key: 'SEND_WHATSAPP_ERROR_MESSAGE',
    value: 'Unable to send whatsapp message'
  },
}

export const  REUSABLE_PAGE_DESIGN  = {
   REUSABLE_PAGE_BUTTON: { key: 'REUSABLE_PAGE_BUTTON', value: 'Reusable pages' },
   ADD_NEW_REUSABLE_PAGE_TOOLTIP: {
    key: 'ADD_NEW_REUSABLE_PAGE_TOOLTIP',
    value: 'Add new Reusable pages',
  },
}

export const  REUSABLE_SECTION_DESIGN  = {
  REUSABLE_SECTION_BUTTON: { key: 'REUSABLE_SECTION_BUTTON', value: 'Reusable sections' },
  ADD_NEW_REUSABLE_SECTION_TOOLTIP: {
    key: 'ADD_NEW_REUSABLE_SECTION_TOOLTIP',
    value: 'Add new Reusable section',
  },
}

export const COMMUNICATION_GENERATOR = {
  COMMUNICATION_GENERATOR_HEADING: {
    key: 'COMMUNICATION_GENERATOR_HEADING',
    value: 'Communication Generator',
  },
  COMMUNICATION_GENERATOR_DESCRIPTION: {
    key: 'COMMUNICATION_GENERATOR_DESCRIPTION',
    value: 'Select your template, channel, and language to get started',
  },
  GENERATE_FORM_FAILED: {
    key: 'GENERATE_FORM_FAILED',
    value: "Communication Id doesn't exist for the channel/language selected",
  },
  VALIDATION_ERROR_MESSAGE: {
    key: 'VALIDATION_ERROR_MESSAGE',
    value: 'There are validation errors in the form. Please correct them and try again.',
  },
  SENDING_EMAIL_FAILED: {
    key: 'SENDING_EMAIL_FAILED',
    value: 'Failed to send email.',
  },
  DOWNLOADING_DOCUMENT_FAILED: {
    key: 'DOWNLOADING_DOCUMENT_FAILED',
    value: 'Error downloading document. Please try again.',
  },
  FAILED_FINDING_COMMUNICATION_INFO: {
    key: 'FAILED_FINDING_COMMUNICATION_INFO',
    value: "Sorry, we couldn't find the communication details for that template.",
  },
  LISTING_COMMUNICATIONS_FAILED: {
    key: 'LISTING_COMMUNICATIONS_FAILED',
    value: 'Unable to list communications name. Please try again later.',
  },
  EMAIL_ADDRESS_EMPTY_ERROR: {
    key: 'EMAIL_ADDRESS_EMPTY_ERROR',
    value: 'Please enter an email address.',
  },
  EMAIL_ADDRESS_EXISTS_ERROR: {
    key: 'EMAIL_ADDRESS_EXISTS_ERROR',
    value: 'This email address already exists.',
  },
  EMAIL_ADDRESS_INVALID_ERROR: {
    key: 'EMAIL_ADDRESS_INVALID_ERROR',
    value: 'This email address is invalid.',
  },
  SELECT_TEMPLATE_LABEL: {
    key: 'SELECT_TEMPLATE_LABEL',
    value: 'Select Template',
  },
  SELECT_TEMPLATE_DESCRIPTION: {
    key: 'SELECT_TEMPLATE_DESCRIPTION',
    value: 'Choose a communication template',
  },
  SEARCH_TEMPLATES_PLACEHOLDER_TEXT: {
    key: 'SEARCH_TEMPLATES_PLACEHOLDER_TEXT',
    value: 'Search templates',
  },
  SELECT_CHANNEL_LABEL: {
    key: 'SELECT_CHANNEL_LABEL',
    value: 'Select Channel',
  },
  SELECT_CHANNEL_DESCRIPTION: {
    key: 'SELECT_CHANNEL_DESCRIPTION',
    value: 'Choose your delivery method',
  },
  PRINT_OPTION: {
    key: 'PRINT_OPTION',
    value: 'Print',
  },
  PRINT_OPTION_DESCRIPTION: {
    key: 'PRINT_OPTION_DESCRIPTION',
    value: 'Physical document for printing',
  },
  EMAIL_OPTION: {
    key: 'EMAIL_OPTION',
    value: 'Email',
  },
  EMAIL_OPTION_DESCRIPTION: {
    key: 'EMAIL_OPTION_DESCRIPTION',
    value: 'Digital delivery via email',
  },
  TO_EMAIL_ADDRESS_LABEL: {
    key: 'TO_EMAIL_ADDRESS_LABEL',
    value: 'To Email Address',
  },
  TO_EMAIL_ADDRESS_DESCRIPTION: {
    key: 'TO_EMAIL_ADDRESS_DESCRIPTION',
    value: 'Add at least one email address by typing it and pressing Enter.',
  },
  TO_EMAIL_ADDRESS_PLACEHOLDER_TEXT: {
    key: 'TO_EMAIL_ADDRESS_PLACEHOLDER_TEXT',
    value: 'Enter recipient email address',
  },
  CC_EMAIL_ADDRESS_LABEL: {
    key: 'CC_EMAIL_ADDRESS_LABEL',
    value: 'CC Email Address (Optional)',
  },
  CC_EMAIL_ADDRESS_DESCRIPTION: {
    key: 'CC_EMAIL_ADDRESS_DESCRIPTION',
    value: 'Add CC recipients',
  },
  CC_EMAIL_ADDRESS_PLACEHOLDER_TEXT: {
    key: 'CC_EMAIL_ADDRESS_PLACEHOLDER_TEXT',
    value: 'Enter CC email address',
  },
  SELECT_LANGUAGE_LABEL: {
    key: 'SELECT_LANGUAGE_LABEL',
    value: 'Select Language',
  },
  SELECT_LANGUAGE_DESCRIPTION: {
    key: 'SELECT_LANGUAGE_DESCRIPTION',
    value: 'Choose your preferred language',
  },
  SELECT_LANGUAGE_PLACEHOLDER_TEXT: {
    key: 'SELECT_LANGUAGE_PLACEHOLDER_TEXT',
    value: 'Select a language',
  },
  GENERATE_FORM_BUTTON: {
    key: 'GENERATE_FORM_BUTTON',
    value: 'Generate Form',
  },
  FILL_REQUIRED_FIELDS_MESSAGE: {
    key: 'FILL_REQUIRED_FIELDS_MESSAGE',
    value: 'Fill in all the required fields',
  },
  CHANNEL_LABEL: {
    key: 'CHANNEL_LABEL',
    value: 'Channel',
  },
  LANGUAGE_LABEL: {
    key: 'LANGUAGE_LABEL',
    value: 'Language',
  },
  NO_VARIABLES_MESSAGE: {
    key: 'NO_VARIABLES_MESSAGE',
    value: 'No details to fill.',
  },
  BACK_BUTTON: {
    key: 'BACK_BUTTON',
    value: 'Back',
  },
  GENERATE_DOCUMENT_BUTTON: {
    key: 'GENERATE_DOCUMENT_BUTTON',
    value: 'Generate Document',
  },
  SEND_EMAIL_BUTTON: {
    key: 'SEND_EMAIL_BUTTON',
    value: 'Send Email',
  },
  DOCUMENT_GENERATED_SUCCESS_MESSAGE: {
    key: 'DOCUMENT_GENERATED_SUCCESS_MESSAGE',
    value: 'Document generated successfully!',
  },
  EMAIL_SENT_SUCCESS_MESSAGE: {
    key: 'EMAIL_SENT_SUCCESS_MESSAGE',
    value: 'Email sent successfully!',
  },
  DOCUMENT_LABEL: {
    key: 'DOCUMENT_LABEL',
    value: 'Document',
  },
  EMAIL_LABEL: {
    key: 'EMAIL_LABEL',
    value: 'Email',
  },
  DOCUMENT_GENERATED_DESCRIPTION: {
    key: 'DOCUMENT_GENERATED_DESCRIPTION',
    value: 'Your document has been generated.',
  },
  EMAIL_SENT_DESCRIPTION: {
    key: 'EMAIL_SENT_DESCRIPTION',
    value: 'Your email has been sent successfully.',
  },
  EDIT_FORM_BUTTON: {
    key: 'EDIT_FORM_BUTTON',
    value: 'Edit Form',
  },
  START_NEW_BUTTON: {
    key: 'START_NEW_BUTTON',
    value: 'Start New',
  },
};